import gql from "graphql-tag";

export const getClientesDsCloudGql = gql`
    query data ($codigoCliente: String, $idSuscripcion: Int, $idPlan: Int){
        clientesDsCloud(codigoCliente:$codigoCliente, idSuscripcion:$idSuscripcion, idPlan:$idPlan){
            codigoCliente
            denominacionCliente
            clienteActivo
            idSuscripcion
            fechaExpiracion
            cuentaSuscripcionActivo
            esDemo
            idCuenta
            nombre
            apPaterno
            apMaterno
            email
            cuentaActivo
            idPlan
            denominacionPlan
        }
    }
`;

export const setEstadoCuentaPorSuscripGql = gql`
    mutation data ($codigoCliente: String!, $idSuscripcion: Int!, $estado:Boolean!){
        cambiarEstadoClientesDsCloud(codigoCliente:$codigoCliente, idSuscripcion:$idSuscripcion, estado:$estado)
    }
`;